export const waitForElement = (
  selector: string,
  callback: (element: Element) => void,
  parentSelector?: string,
  keepMonitoringAfterFound?: boolean
) => {
  const parent = (parentSelector ? document.querySelector(parentSelector) : document) || document;
  const element = parent.querySelector(selector);
  if (element) {
    callback(element);
  } else {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        const addedNodes = Array.from(mutation.addedNodes);

        for (const node of addedNodes) {
          if (node instanceof HTMLElement) {
            if (node.matches(selector)) {
              callback(node);
              if (!keepMonitoringAfterFound) {
                observer.disconnect();
              }
              return;
            }

            if (node.querySelector(selector)) {
              callback(node);
              if (!keepMonitoringAfterFound) {
                observer.disconnect();
              }
              return;
            }
          }
        }
      }
    });

    observer.observe(parent, { childList: true, subtree: true });
  }
};
